import React from 'react'

import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import { FlexPaper } from 'src/utils/views'

export type ProfileCardProps = {
    className?: string
    caption?: React.ReactNode
    style?: React.CSSProperties
    children?: React.ReactNode
}

export default function ProfileCard(props: ProfileCardProps) {
    return (
        <Box sx={{ paddingLeft: 4, paddingRight: 4, marginBottom: 4 }}>
            <FlexPaper className={props.className} style={props.style} elevation={3} sx={{ p: 4 }}>
                {props.caption && (
                    <Typography variant="h6" gutterBottom>
                        {props.caption}
                    </Typography>
                )}

                {props.children}
            </FlexPaper>
        </Box>
    )
}
